import { Component, Input } from '@angular/core';

@Component({
  selector: 'mojo-best-job',
  templateUrl: './best-job.component.html',
  styleUrls: ['./best-job.component.scss'],
})
export class BestJobComponent {
  @Input() showCrown = false;
}
